import React, { useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Box, Button, Typography } from "@mui/material";
import Spinner from "../../components/Spinner/Spinner";
import { get } from "../../axiosUtils/appUtils";
import Toast from "../../components/Toast/Toast";
import * as XLSX from 'xlsx';

const AuditLogs = () => {
  const [value, setValue] = React.useState(null);
  const [value2, setValue2] = React.useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [toastType, setToastType] = useState("success");

  // close toast
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleDownload = () => {
    console.log("value", value ? value.format("DD-MM-YYYY") : null);
    console.log("value2",value2 ? value2.format("DD-MM-YYYY") : null);

     const MYdata = [
              {"title":'Title1', "website":"Foo"},
              {"title":'Title2', "website":"Bar"}
            ]

            const worksheet = XLSX.utils.json_to_sheet(MYdata);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            XLSX.writeFile(workbook, "MYSavedData.xlsx");
            setToastMsg("File downloaded successfully");
            setToastType("success");
            setOpen(true);
            setValue(null);
            setValue2(null);


    // setLoading(true);
    //     const url = `url`;
    //     get(url)
    //       .then((response) => {
    //         console.log("response", response);
    //         setOpen(true);
    //         setToastMsg("MODIFY_DETAILS_ERROR_MESSAGE");
    //         setToastType("error");            
    //         setLoading(false);

    //         // const MYdata = [
    //         //   {"title":Title1, "website":"Foo"},
    //         //   {"title":Title2, "website":"Bar"}
    //         // ]

    //         // const worksheet = XLSX.utils.json_to_sheet(MYdata);
    //         // const workbook = XLSX.utils.book_new();
    //         // XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    //         // XLSX.writeFile(workbook, "MYSavedData.xlsx");
    //       })
    //       .catch((error) => {
    //         setLoading(false);
    //         setOpen(true);
    //         setToastMsg("MODIFY_DETAILS_ERROR_MESSAGE");
    //         setToastType("error");
    //       });
  }


return (
    <>
        <Typography
                  variant="h6"
                  component="div"
                  sx={{ flexGrow: 1, fontWeight: "bold", marginBottom: 2 }}
                >
                 Download Audit logs report
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                label="Start Date*"
                value={value}
                onChange={(newValue) => setValue(newValue)}
                disableFuture
            />
        </LocalizationProvider>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                label="End Date*"
                value={value2}
                onChange={(newValue) => setValue2(newValue)}
                disableFuture
            />
        </LocalizationProvider>

        <Button variant="contained" onClick={handleDownload} disabled={!value || !value2}>Download</Button>
        </Box>
        {loading && <Spinner />}
         <Toast
                  toastMsg={toastMsg}
                  open={open}
                  handleClose={handleClose}
                  severity={toastType}
                />
    </>
);
};

export default AuditLogs;
